import { render, staticRenderFns } from "./feeConfigDetailList.vue?vue&type=template&id=37d9efa6&scoped=true"
import script from "./feeConfigDetailList.vue?vue&type=script&lang=js"
export * from "./feeConfigDetailList.vue?vue&type=script&lang=js"
import style0 from "./feeConfigDetailList.vue?vue&type=style&index=0&id=37d9efa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d9efa6",
  null
  
)

export default component.exports